class ScrollDownNavigation extends HTMLElement {
  constructor() {
    super();
    this.productItems = [];
    this.leftContent = null;
    this.rightSection = null;
    this.section = null;
    this.observer = null;
    this.ticking = false;
  }

  connectedCallback() {
    requestAnimationFrame(() => {
      this.initializeElements();
      if (this.productItems.length > 0) {
        this.setupIntersectionObserver();
        this.setupEventListeners();
      }
    });
  }

  disconnectedCallback() {
    this.cleanup();
  }

  initializeElements() {
    this.productItems = this.querySelectorAll('.scroll-down-navigation__product-item');
    this.leftContent = this.querySelector('.scroll-down-navigation__content');
    this.rightSection = this.querySelector('.scroll-down-navigation__right');
    this.section = this;
  }

  findCenteredItem() {
    let centeredItem = null;
    let closestDistance = Infinity;
    const viewportHeight = window.innerHeight;
    const screenCenter = viewportHeight / 2;

    this.productItems.forEach((item) => {
      const rect = item.getBoundingClientRect();
      const itemCenter = rect.top + rect.height / 2;
      const distanceFromCenter = Math.abs(itemCenter - screenCenter);

      const isVisible = rect.bottom > 0 && rect.top < viewportHeight;

      if (isVisible && distanceFromCenter < closestDistance) {
        closestDistance = distanceFromCenter;
        centeredItem = item;
      }
    });

    return centeredItem;
  }

  updateActiveItem() {
    const centeredItem = this.findCenteredItem();

    this.productItems.forEach((item) => item.classList.remove('in-view'));

    if (centeredItem) {
      centeredItem.classList.add('in-view');
    }
  }

  setupIntersectionObserver() {
    const observerOptions = {
      root: null,
      rootMargin: '-40% 0px -40% 0px',
      threshold: [0, 0.1, 0.2, 0.3, 0.4, 0.5, 0.6, 0.7, 0.8, 0.9, 1.0],
    };

    this.observer = new IntersectionObserver((entries) => {
      this.updateActiveItem();
    }, observerOptions);

    this.productItems.forEach((item) => {
      this.observer.observe(item);
    });
  }

  updateOnScroll() {
    if (!this.ticking) {
      requestAnimationFrame(() => {
        this.updateActiveItem();
        this.ticking = false;
      });
      this.ticking = true;
    }
  }

  setupEventListeners() {
    this.handleScroll = this.updateOnScroll.bind(this);
    this.handleBeforeUnload = this.cleanup.bind(this);

    window.addEventListener('scroll', this.handleScroll);
    window.addEventListener('beforeunload', this.handleBeforeUnload);
  }

  cleanup() {
    if (this.observer) {
      this.observer.disconnect();
    }

    if (this.handleScroll) {
      window.removeEventListener('scroll', this.handleScroll);
    }

    if (this.handleBeforeUnload) {
      window.removeEventListener('beforeunload', this.handleBeforeUnload);
    }
  }
}

customElements.define('scroll-down-navigation', ScrollDownNavigation);
